import dragCountEntry from './dragCountEntry';

// ----------------------------------------------------------------------------

async function dragCount(evt: DragEvent): Promise<number> {
    const dataTransfer = evt.dataTransfer;

    const entries = Array.from(dataTransfer?.items ?? [])
        .filter((item): any => item.kind === 'file')
        .map((item): any => item.webkitGetAsEntry())
        .filter((entry): entry is FileSystemEntry => entry != null);

    if (entries.length === 0) {
        return dataTransfer?.files.length ?? 0;
    }

    const counts = await Promise.all(entries.map(dragCountEntry));

    return counts.reduce((sum, c): any => sum + c, 0);
}

// ----------------------------------------------------------------------------

export default dragCount;
